import { render } from "./DashboardInfoBlock.vue?vue&type=template&id=415593b6&scoped=true"
import script from "./DashboardInfoBlock.vue?vue&type=script&lang=js"
export * from "./DashboardInfoBlock.vue?vue&type=script&lang=js"

import "./DashboardInfoBlock.vue?vue&type=style&index=0&id=415593b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-415593b6"

export default script